import axios from 'axios'
import {getToken} from './common'

axios.defaults.baseURL = "https://gateway.r2g.com.cn"
axios.defaults.withCredentials = true
let appId = "6391ee1c773b606a569d15fb3eb43f0c"

let isRequesting = {}


export function get(url, needLogin = true) {

    let ctoken = getToken()
    if (url.indexOf("?") == -1) {
        url += "?appId=" + appId + "&token=" + ctoken
    } else {
        url += "&appId=" + appId + "&token=" + ctoken
    }

    if (isRequesting[url]) {
        return new Promise((resolve, reject) => {
            reject("请勿重复操作")
        })
    }

    isRequesting[url] = true

    return new Promise((resolve, reject) => {
        if (needLogin && !ctoken) {
            resolve({code: 2, message: "账号未登录"})
            isRequesting[url] = false
            return
        }
        axios.get(url).then(response => {
            if (response.status !== 200) {
                reject("网络请求失败")
                return
            }
            // let data = response.data
            // if (data.code !== 0) {
            //     reject(data)
            //     return
            // }
            resolve(response.data)
        }).catch(e => {
            reject(e)
        }).finally(() => {
            isRequesting[url] = false
        })
    })
}

export function post(url, data, needLogin = true) {

    let ctoken = getToken()
    if (url.indexOf("?") == -1) {
        url += "?appId=" + appId + "&token=" + ctoken
    } else {
        url += "&appId=" + appId + "&token=" + ctoken
    }

    if (isRequesting[url]) {
        return new Promise((resolve, reject) => {
            console.log("请勿重复操作", url, data)
            reject("请勿重复操作")
        })
    }

    isRequesting[url] = true

    return new Promise((resolve, reject) => {
        if (needLogin && !ctoken) {
            resolve({code: 2, message: "账号未登录"})
            isRequesting[url] = false
            return
        }
        axios.post(url, data).then(response => {
            if (response.status !== 200) {
                reject("网络请求失败")
                return
            }
            // let data = response.data
            // if (data.code !== 0) {
            //     reject(data)
            //     return
            // }
            resolve(response.data)
        }).catch(e => {
            reject(e)
        }).finally(() => {
            isRequesting[url] = false
        })
    })

}